import {
  useEffect, useMemo, useRef, memo,
} from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useStore } from 'react-redux';
import { routing as routingSelectors } from 'redux-selectors';
import { ModalRoutingContext } from 'bv-contexts';
import { refresh, isModal } from 'bv-services/route';
import { ModalRoutes, MainRoutes } from './components';
import { setProductIdCookie } from './helpers';
import { useIsFirstModal } from './hooks';

const { getCurrentPath, getCurrentPathWithoutLocale } = routingSelectors;

const ModalSwitch = () => {
  const location = useLocation();
  const previousPathWithoutLocale = useSelector(getCurrentPathWithoutLocale);
  const ifPathnameWithQueryParams = location.pathname.split('?');
  if (ifPathnameWithQueryParams.length > 1
    && ifPathnameWithQueryParams[0] === previousPathWithoutLocale) {
    location.pathname = previousPathWithoutLocale;
  }
  location.search = window.location.search;
  const lastMainLocation = useRef({ pathname: '/' });
  const currentPath = useSelector(getCurrentPath);
  const store = useStore();

  const locationIsModal = isModal(location.pathname);

  useEffect(() => {
    // Once all routing is in react, we do not need to store currentPath in redux
    // And the stuff done in RouteService can be done with a component using an effect
    // Like this one, executed when the pathname changes
    refresh();
    if (!locationIsModal) lastMainLocation.current = location;
  }, [location]);

  useEffect(() => {
    setProductIdCookie(store.getState());
  }, [currentPath, store]);

  const isFirstModal = useIsFirstModal(locationIsModal);
  const mainLocation = locationIsModal ? lastMainLocation.current : location;

  const contextValue = useMemo(() => ({ isFirstModal }), [isFirstModal]);

  return (
    <>
      <MainRoutes location={mainLocation} />
      <ModalRoutingContext.Provider value={contextValue}>
        <ModalRoutes />
      </ModalRoutingContext.Provider>
    </>
  );
};

const RoutingView = memo(() => (
  <ModalSwitch />
));

export default RoutingView;
